export default function handleTextColor(color, styles) {
  switch (color) {
    case "white":
      return styles._color_white;
    case "black":
      return styles._color_black;
    case "blue":
      return styles._color_blue;
    case "purple":
      return styles._color_purple;
    default:
      return "";
  }
}
